import { useState, useMemo } from 'react'
import AssessmentsCard from '../AssessmentsCard'
import FollowUpsView from '../FollowUpsView'

function AssessmentsTab({ client }) {
  const [activeTab, setActiveTab] = useState('assessments')

  const flagCount = useMemo(() => {
    return (client.assessments || []).reduce((sum, a) => {
      const flags = a.responses?.flags || a.responses?.notes?.flags || {}
      return sum + Object.keys(flags).length
    }, 0)
  }, [client.assessments])

  const tabs = [
    {
      id: 'assessments',
      label: 'Assessments',
      icon: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      ),
    },
    {
      id: 'follow-ups',
      label: 'Follow-ups',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2z" />
        </svg>
      ),
      badge: flagCount > 0 ? flagCount : null,
    },
  ]

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Assessments</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          Manage discovery assessments and review flagged questions for client follow-up.
        </p>
      </div>

      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-8">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === tab.id
                  ? 'border-primary-500 text-primary-600 dark:text-accent-300'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }
              `}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.label}
              {tab.badge != null && (
                <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium rounded-full bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300">
                  {tab.badge}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>

      <div className="pt-2">
        {activeTab === 'assessments' && <AssessmentsCard client={client} />}
        {activeTab === 'follow-ups' && <FollowUpsView client={client} />}
      </div>
    </div>
  )
}

export default AssessmentsTab
